import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Do I need to know how to crochet to use this ebook?',
  a: 'No! We include 10 video classes of basic crochet stitches as a bonus, designed for absolute beginners. You will learn from scratch: magic ring, single crochet, increases, decreases, and everything you need to follow the patterns with confidence.'
}, {
  q: 'How do I receive the ebook?',
  a: 'It is a 100% digital product. Immediately after your payment, you will receive an email with the direct download link in PDF format.'
}, {
  q: 'Can I sell the amigurumis I crochet?',
  a: 'Yes, absolutely! In fact, we encourage entrepreneurs to use these designs. The only thing you cannot sell or share is the pattern (the PDF file) itself.'
}, {
  q: 'Are the patterns in English?',
  a: 'Yes, all content is written in clear, simple English with standard crochet terms.'
}, {
  q: 'What if I have questions while crocheting?',
  a: 'The ebook is very detailed, but if you get stuck on any step, you can write to our support email included in your purchase and we will gladly help you.'
}, {
  q: 'Is there a guarantee?',
  a: 'Yes, you have a 7-day satisfaction guarantee. If the ebook does not meet your expectations, we will refund your money with no questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-16 bg-white" data-id="element-114">
      <div className="max-w-3xl mx-auto px-4" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-117">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-118">
          {faqs.map((faq, index) => <div key={index} className="etsy-card overflow-hidden" data-id="element-119">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-120">
                <span className="font-bold text-deep-brown text-sm pr-4" data-id="element-121">
                  {faq.q}
                </span>
                <ChevronDown size={18} className={`text-copper flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-122" />
              </button>
              <AnimatePresence data-id="element-123">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-124">
                    <div className="px-5 pb-5 text-gray-500 leading-relaxed text-sm border-t border-gray-50 pt-4" data-id="element-125">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}